module.exports = __webpack_public_path__ + "fd78dd7105c2a7a32fe6093778e9c09e.png";